import type React from 'react';
import { cn } from '@/lib/utils';

/**
 * Skeleton (registry @coss/skeleton) adaptado a Tailwind v3.4: shimmer
 * mediante una banda que barre el bloque (animación `skeleton` definida en
 * tailwind.config.ts). La versión original usaba `@theme inline` + tokens v4.
 */
export function Skeleton({
  className,
  ...props
}: React.ComponentProps<'div'>): React.ReactElement {
  return (
    <div
      className={cn('relative overflow-hidden rounded-md bg-muted', className)}
      data-slot="skeleton"
      {...props}
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 animate-skeleton bg-gradient-to-r from-transparent via-foreground/10 to-transparent"
      />
    </div>
  );
}
